import React from "react";
import { CTASection, Footer, Header } from "./LandingPageNewUI";
import "./LandingPageNewUI.css";

const ContactUs = () => (
  <div
    className="landing-page-wrapper"
    style={{
      minHeight: "100vh",
      backgroundColor: "hsl(var(--background))",
      color: "hsl(var(--foreground))",
    }}
  >
    <Header />
    <main>
      <CTASection />
    </main>
    <Footer />
  </div>
);

export default ContactUs;
